module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/change-property/change-property.component.css
// module id = ./src/app/allocation/change-property/change-property.component.css
// module chunks = main